import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface ShippingSettings {
  free_shipping_threshold: number;
  shipping_fee: number;
}

const DEFAULTS: ShippingSettings = {
  free_shipping_threshold: 50,
  shipping_fee: 4.99,
};

export const useShippingSettings = () => {
  const [settings, setSettings] = useState<ShippingSettings>(DEFAULTS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await supabase
          .from('site_settings')
          .select('setting_key, setting_value')
          .in('setting_key', ['free_shipping_threshold', 'shipping_fee']);

        if (!mounted || !data) return;

        const next = { ...DEFAULTS };
        for (const row of data as any[]) {
          const raw = row.setting_value;
          const num = typeof raw === 'number' ? raw : Number(raw?.value ?? raw);
          if (!Number.isNaN(num)) {
            if (row.setting_key === 'free_shipping_threshold') next.free_shipping_threshold = num;
            if (row.setting_key === 'shipping_fee') next.shipping_fee = num;
          }
        }
        setSettings(next);
      } catch (e) {
        console.error('useShippingSettings error:', e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, []);

  return { ...settings, loading };
};
